module.exports = __webpack_public_path__ + "img/Y_078_1p9c.86323ee0.png";